import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LOCALE_ID, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
//taost
import { NotifierModule, NotifierOptions } from 'angular-notifier';
//paginacion
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import * as $ from 'jquery';
//app autocomplete
import { NgSelectModule } from '@ng-select/ng-select';

// Forms module
import { FormsModule } from '@angular/forms';
import { AuthGuard } from './Security/auth.guard';
import { LoginComponent } from './Components/Usuario/login/login.component';
import { ReactiveFormsModule } from '@angular/forms';
import { HeaderComponent } from './Components/Default/header/header.component';
import { NavbarComponent } from './Components/Default/navbar/navbar.component';
import { SidebarComponent } from './Components/Default/sidebar/sidebar.component';
import { FooterComponent } from './Components/Default/footer/footer.component';
import { LoadingComponent } from './Components/objects/loading/loading.component';
import { NothingComponent } from './Components/objects/nothing/nothing.component';
import { AlertComponent } from './Components/objects/alert/alert/alert.component';
import { DeleteModalComponent } from './Components/objects/delete/delete-modal/delete-modal.component';
import { ModalComponent } from './Components/objects/modal/modal/modal.component';
import { InfoComponent } from './Components/objects/info/info/info.component';
import { MessageComponent } from './Components/objects/message/message/message.component';
import { SpanComponent } from './Components/objects/span/span/span.component';
import { UnidadMedidaComponent } from './Components/unidad/unidad-medida/unidad-medida.component';
import { TipoProductoComponent } from './Components/tipoproducto/tipo-producto/tipo-producto.component';
import { WaitingComponent } from './Components/objects/waiting/waiting/waiting.component';
import { IndexComponent } from './Components/index/index/index.component';
import { ArticuloComponent } from './Components/articulo/articulo/articulo.component';
import { ArticuloEditComponent } from './Components/articulo/articulo-edit/articulo-edit.component';
import { ClaseComponent } from './Components/clase/clase/clase.component';
import { SubClaseComponent } from './Components/subclase/sub-clase/sub-clase.component';
import { SubGrupoComponent } from './Components/subgrupo/sub-grupo/sub-grupo.component';
import { CatalogoProductoComponent } from './Components/catalogoproducto/catalogo-producto/catalogo-producto.component';
import { PreciosComponent } from './Components/precios/precios/precios.component';
import { ClienteIndexComponent } from './Components/cliente/cliente-index/cliente-index.component';
import { DialogAfectoIgvComponent } from './Components/afectoigv/dialog/dialog-afecto-igv/dialog-afecto-igv.component';
import { ClienteEditComponent } from './Components/cliente/cliente-edit/cliente-edit.component';
import { ClienteDialogComponent } from './Components/cliente/cliente-dialog/cliente-dialog.component';
import { ArticuloDialogComponent } from './Components/articulo/articulo-dialog/articulo-dialog.component';
import { PedidoIndexComponent } from './Components/pedido/pedido-index/pedido-index.component';
import { PedidoListComponent } from './Components/pedido/pedido-list/pedido-list.component';
import { PedidoDialogComponent } from './Components/pedido/pedido-dialog/pedido-dialog.component';
import { TableRowComponent } from './Modules/table/table-row/table-row.component';
import { PedidoIndexTableRowComponent } from './Components/pedido/pedido-index/elements/pedido-index-table-row/pedido-index-table-row.component';
import { PrintPedidoComponent } from './Components/print/print-pedido/print-pedido.component';
import { StringToNumberPipe } from './string-to-number.pipe';
import { ClienteRegisterComponent } from './Components/cliente/cliente-register/cliente-register.component';
import { ComprasComponent } from './Components/compras/compras.component';
import { ComprasProveedorComponent } from './Components/compras/compras-proveedor/compras-proveedor.component';
import { ComprasArticuloComponent } from './Components/compras/compras-detcompra/compras-detcompra.component';
import { AjusteComponent } from './Components/ajuste/ajuste.component';
import { DatePipe } from '@angular/common';
import { VentasDetalladoComponent } from './Components/informes/ventas-detallado/ventas-detallado.component';
import { VentaProductDetalladoComponent } from './Components/informes/venta-product-detallado/venta-product-detallado.component';
import { ComprasInformesComponent } from './Components/informes/compras-informes/compras-informes.component';
import { ComprasDetallesInformesComponent } from './Components/informes/compras-detalles-informes/compras-detalles-informes.component';
import { PrintVentasComponent } from './Components/print/print-ventas/print-ventas.component';
import { VentasComponent } from './Components/informes/ventas/ventas.component';
import { PrintVentasProductosComponent } from './Components/print/print-ventas-productos/print-ventas-productos.component';
import { PrintComprasComponent } from './Components/print/print-compras/print-compras.component';
import { PrintComprasProductosComponent } from './Components/print/print-compras-productos/print-compras-productos.component';
import { ComprasinfComponent } from './Components/informes/compras/comprasinf.component';
import { ConfiguracionComponent } from './Components/configuracion/configuracion.component';
import { PrintKardexComponent } from './Components/print/print-kardex/print-kardex.component';
import { KardexComponent } from './Components/informes/kardex/kardex.component';
import { FacturacionComponent } from './Components/facturacion/facturacion.component';
import { AddFacturaComponent } from './Components/facturacion/add-factura/add-factura.component';
import { EditFacturaComponent } from './Components/facturacion/edit-factura/edit-factura.component';
import { PrintFacturaComponent } from './Components/print/print-factura/print-factura.component';
import { PrintBoletaComponent } from './Components/print/print-boleta/print-boleta.component';
import { AddCompraComponent } from './Components/compras/add-compra/add-compra.component';
import { LiquidacionComponent } from './Components/liquidacion/liquidacion.component';
import { DetalleCargaLiqComponent } from './Components/liquidacion/detalle-carga-liq/detalle-carga-liq.component';
import { AddLiquidacionComponent } from './Components/liquidacion/add-liquidacion/add-liquidacion.component';
import { GastosComponent } from './Components/gastos/gastos.component';
import { IngresosComponent } from './Components/ingresos/ingresos.component';
import { SearchFacturaComponent } from './Components/compras/search-factura/search-factura.component';
import { SaldosComponent } from './Components/saldos/saldos.component';
import { PrintliquidacionComponent } from './Components/print/printliquidacion/printliquidacion.component';
import { PersonalComponent } from './Components/personal/personal.component';
import { AnularFacturaComponent } from './Components/facturacion/anular-factura/anular-factura.component';
import { AddPersonalComponent } from './Components/personal/add-personal/add-personal.component';
import { TestComponent } from './Components/test/test.component';
import { PrintVentasaClientesComponent } from './Components/print/print-ventasa-clientes/print-ventasa-clientes.component';
import { VentasClientesComponent } from './Components/informes/ventas-clientes/ventas-clientes.component';
import { PrintVentasPorVendedorComponent } from './Components/print/print-ventas-por-vendedor/print-ventas-por-vendedor.component';
import { SelectSucursalComponent } from './Components/select-sucursal/select-sucursal.component';
import { PrintVentasPorClienteComponent } from './Components/print/print-ventas-por-cliente/print-ventas-por-cliente.component';
import { VentasPorMesYClientesComponent } from './Components/print/ventas-por-mes-yclientes/ventas-por-mes-yclientes.component';
import { SucursalComponent } from './Components/sucursal/sucursal.component';
import { AddSucursalComponent } from './Components/sucursal/add-sucursal/add-sucursal.component';
import { PrintVentasPorZonasComponent } from './Components/print/print-ventas-por-zonas/print-ventas-por-zonas.component';
import { AddAjusteComponent } from './Components/ajuste/add-ajuste/add-ajuste.component';
import { ZonasComponent } from './Components/zonas/zonas.component';
import { AddZonaComponent } from './Components/zonas/add-zona/add-zona.component';
import { PrestamosComponent } from './Components/prestamos/prestamos.component';
import { UbicacionComponent } from './Components/ubicacion/ubicacion.component';
import { AddUbicacionComponent } from './Components/ubicacion/add-ubicacion/add-ubicacion.component';
import { PrintVentasDiariasComponent } from './Components/print/print-ventas-diarias/print-ventas-diarias.component';
import { LimitarDecimalesDirective } from './Directives/limitar-decimales/limitar-decimales.directive';
import { ChangePersonalComponent } from './Components/facturacion/change-personal/change-personal.component';
import { VentasPorHoraVendedorComponent } from './Components/informes/ventas-por-hora-vendedor/ventas-por-hora-vendedor.component';
import { SetPrestamoComponent } from './Components/pedido/pedido-index/set-prestamo/set-prestamo.component';
import { ListaSaldosComponent } from './Components/lista-saldos/lista-saldos.component';
import { PrintVentasDiariasDetalladoComponent } from './Components/print-ventas-diarias-detallado/print-ventas-diarias-detallado.component';
import { ReportViewerModalComponent } from './shared/report-viewer-modal/report-viewer-modal.component';
import { PrintVentasPorCategoriaPreciosComponent } from './Components/print-ventas-por-categoria-precios/print-ventas-por-categoria-precios.component';
import { PrintReporteGastosDetalladoComponent } from './Components/print-reporte-gastos-detallado/print-reporte-gastos-detallado.component';
import { PrintReporteUtilidadesComponent } from './Components/print-reporte-utilidades/print-reporte-utilidades.component';
import { PrintVentasClienteAnualComponent } from './Components/print/print-ventas-cliente-anual/print-ventas-cliente-anual.component';
import { ProveedorComponent } from './Components/proveedor/proveedor.component';
import { AddProveedorComponent } from './Components/proveedor/add-proveedor/add-proveedor.component';
import { MatButtonModule, MatCardModule, MatDialogModule, MatIconModule, MatInputModule, MatPaginatorModule, MatSelectModule, MatTableModule } from '@angular/material';
import { CargoComponent } from './Components/Maestros/cargo/cargo.component';
import { TipoContratoComponent } from './Components/Maestros/tipo-contrato/tipo-contrato.component';
import { AfpEmpresaComponent } from './Components/Maestros/afp-empresa/afp-empresa.component';
import { EstadoPlanillaComponent } from './Components/Maestros/estado-planilla/estado-planilla.component';
import { EstadoPeriodoComponent } from './Components/Maestros/estado-periodo/estado-periodo.component';
import { FormasDePagoComponent } from './Components/Maestros/formas-de-pago/formas-de-pago.component';
import { BancosComponent } from './Components/Maestros/bancos/bancos.component';
import { ConceptpPlanillaComponent } from './Components/Maestros/conceptp-planilla/conceptp-planilla.component';
import { AddAfpEmpresaComponent } from './Components/Maestros/afp-empresa/add-afp-empresa/add-afp-empresa.component';
import { AddBancoComponent } from './Components/Maestros/bancos/add-banco/add-banco.component';
import { AddCargoComponent } from './Components/Maestros/cargo/add-cargo/add-cargo.component';
import { AddConceptoPlantillaComponent } from './Components/Maestros/conceptp-planilla/add-concepto-plantilla/add-concepto-plantilla.component';
import { AddEstadoPeriodoComponent } from './Components/Maestros/estado-periodo/add-estado-periodo/add-estado-periodo.component';
import { AddEstadoPlanillaComponent } from './Components/Maestros/estado-planilla/add-estado-planilla/add-estado-planilla.component';
import { AddFormasDePagoComponent } from './Components/Maestros/formas-de-pago/add-formas-de-pago/add-formas-de-pago.component';
import { AddTipoContratoComponent } from './Components/Maestros/tipo-contrato/add-tipo-contrato/add-tipo-contrato.component';
import { PeriodoPagoComponent } from './Components/Maestros/periodo-pago/periodo-pago.component';
import { PlanillaMensualComponent } from './Components/Planilla/planilla-mensual/planilla-mensual.component';

// import { ReportViewerModalComponent } from './Shared/report-viewer-modal/report-viewer-modal.component';


const customNotifierOptions: NotifierOptions = {
  position: {
    horizontal: {
      position: 'right',
      distance: 12
    },
    vertical: {
      position: 'top',
      distance: 12,
      gap: 10
    }
  },
  theme: 'material',
  behaviour: {
    autoHide: 5000,
    onClick: 'hide',
    onMouseover: 'pauseAutoHide',
    showDismissButton: true,
    stacking: 4
  },
  animations: {
    enabled: true,
    show: {
      preset: 'slide',
      speed: 300,
      easing: 'ease'
    },
    hide: {
      preset: 'fade',
      speed: 300,
      easing: 'ease',
      offset: 50
    },
    shift: {
      speed: 300,
      easing: 'ease'
    },
    overlap: 150
  }
};

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HeaderComponent,
    NavbarComponent,
    SidebarComponent,
    FooterComponent,
    LoadingComponent,
    NothingComponent,
    AlertComponent,
    DeleteModalComponent,
    ModalComponent,
    InfoComponent,
    MessageComponent,
    SpanComponent,
    TipoProductoComponent,
    WaitingComponent,
    IndexComponent,
    ArticuloComponent,
    ArticuloEditComponent,
    ClaseComponent,
    SubClaseComponent,
    SubGrupoComponent,
    CatalogoProductoComponent,
    PreciosComponent,
    UnidadMedidaComponent,
    ClienteIndexComponent,
    DialogAfectoIgvComponent,
    ClienteEditComponent,
    ClienteDialogComponent,
    ArticuloDialogComponent,
    PedidoIndexComponent,
    PedidoListComponent,
    PedidoDialogComponent,
    TableRowComponent,
    PedidoIndexTableRowComponent,
    PrintPedidoComponent,
    StringToNumberPipe,
    ClienteRegisterComponent,
    ComprasComponent,
    ComprasProveedorComponent,
    ComprasArticuloComponent,
    AjusteComponent,
    VentasDetalladoComponent,
    VentaProductDetalladoComponent,
    ComprasInformesComponent,
    ComprasDetallesInformesComponent,
    PrintVentasComponent,
    VentasComponent,
    PrintVentasProductosComponent,
    PrintComprasComponent,
    PrintComprasProductosComponent,
    ComprasinfComponent,
    ConfiguracionComponent,
    PrintKardexComponent,
    KardexComponent,
    FacturacionComponent,
    AddFacturaComponent,
    EditFacturaComponent,
    SearchFacturaComponent,
    PrintFacturaComponent,
    PrintBoletaComponent,
    AddCompraComponent,
    LiquidacionComponent,
    DetalleCargaLiqComponent,
    AddLiquidacionComponent,
    GastosComponent,
    IngresosComponent,
    SaldosComponent,
    PrintliquidacionComponent,
    PersonalComponent,
    AnularFacturaComponent,
    AddPersonalComponent,
    TestComponent,
    PrintVentasaClientesComponent,
    VentasClientesComponent,
    PrintVentasPorVendedorComponent,
    SelectSucursalComponent,
    PrintVentasPorClienteComponent,
    VentasPorMesYClientesComponent,
    SucursalComponent,
    AddSucursalComponent,
    PrintVentasPorZonasComponent,
    AddAjusteComponent,
    ZonasComponent,
    AddZonaComponent,
    PrestamosComponent,
    UbicacionComponent,
    AddUbicacionComponent,
    PrintVentasDiariasComponent,
    LimitarDecimalesDirective,
    ChangePersonalComponent,
    VentasPorHoraVendedorComponent,
    SetPrestamoComponent,
    ListaSaldosComponent,
    PrintVentasDiariasDetalladoComponent,
    ReportViewerModalComponent,
    PrintVentasPorCategoriaPreciosComponent,
    PrintReporteGastosDetalladoComponent,
    PrintReporteUtilidadesComponent,
    PrintVentasClienteAnualComponent,
    ProveedorComponent,
    AddProveedorComponent,
    CargoComponent,
    TipoContratoComponent,
    AfpEmpresaComponent,
    EstadoPlanillaComponent,
    EstadoPeriodoComponent,
    FormasDePagoComponent,
    BancosComponent,
    ConceptpPlanillaComponent,
    AddAfpEmpresaComponent,
    AddBancoComponent,
    AddCargoComponent,
    AddConceptoPlantillaComponent,
    AddEstadoPeriodoComponent,
    AddEstadoPlanillaComponent,
    AddFormasDePagoComponent,
    AddTipoContratoComponent,
    PeriodoPagoComponent,
    PlanillaMensualComponent,


  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    NotifierModule.withConfig(customNotifierOptions),
    NgbModule,
    NgSelectModule,
    NgxPaginationModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatDialogModule
  ],
  providers: [AuthGuard, DatePipe, { provide: LOCALE_ID, useValue: 'en' }],
  bootstrap: [AppComponent],
  entryComponents: [
    ChangePersonalComponent,
    VentasPorHoraVendedorComponent,
    SetPrestamoComponent,
    AddProveedorComponent
  ]
})
export class AppModule { }
